import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Flights from "@/pages/Flights";
import Hotels from "@/pages/Hotels";
import Packages from "@/pages/Packages";
import Deals from "@/pages/Deals";
import VisaGuides from "@/pages/VisaGuides";
import VisaGuideDetail from "@/pages/VisaGuideDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { Privacy, Terms, AffiliateDisclosure, NotFound } from "@/pages/Legal";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="flights" element={<Flights />} />
            <Route path="hotels" element={<Hotels />} />
            <Route path="packages" element={<Packages />} />
            <Route path="deals" element={<Deals />} />
            <Route path="visa-guides" element={<VisaGuides />} />
            <Route path="visa-guides/:slug" element={<VisaGuideDetail />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="destinations" element={<Destinations />} />
            <Route path="destinations/:slug" element={<DestinationDetail />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="affiliate-disclosure" element={<AffiliateDisclosure />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
